<template>
  <div>
    <w-radio-list :values="values" :title="title" :model="schema.confirmedDocument.CONFIRMED_SIGNED.passed" />

    <w-radio-list
      class="mt-4"
      :values="values"
      :title="title"
      :model="schema.confirmedDocument.CONFIRMED_COMPLETED.passed"
    />

    <w-radio-list
      class="mt-4"
      :values="values"
      :title="title"
      :model="schema.confirmedDocument.CONFIRMED_ATTACHMENTS.passed"
    />
  </div>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';

// @vuese
// Formularz potwierdzania
export default {
  mixins: [componentMixin],
  props: {
    // schema
    schema: { type: Object, required: true }
  },
  data() {
    return {
      values: [
        { value: 1, text: 'Tak' },
        { value: 3, text: 'Nie' }
      ]
    };
  }
};
</script>
